// $(document).ready(function () {
//   // Function to show brands
//   function showBrands(startIndex, endIndex) {
//     $("#menu_mb_ul li").slice(startIndex, endIndex).show();
//   }

//   // Initially show the first 10 brands when .mb_nav_ul is clicked
//   $(document).on("click", ".mb_nav_ul", function () {
//     showBrands(0, 10); // Show first 10 brands
//   });

//   // Event listener for "Show More" button
//   $(document).on("click", "#show-more-btn", function () {
//     var visibleCount = $("#menu_mb_ul li:visible").length;
//     var endIndex = visibleCount + 10; // Calculate the end index for the next batch of brands
//     showBrands(visibleCount, endIndex);

//     // Hide the button if there are no more hidden brands
//     if ($("#menu_mb_ul li:hidden").length === 0) {
//       $(this).hide();
//     }
//   });

//   // Event listener for search box input
//   $(document).on("input", ".brand-search-box", function () {
//     var searchQuery = $(this).val().toLowerCase();
//     var found = false;

//     $("#menu_mb_ul li").each(function () {
//       var brandName = $(this).find("a span:last-child").text().toLowerCase();
//       if (brandName.includes(searchQuery)) {
//         $(this).show();
//         found = true;
//       } else {
//         $(this).hide();
//       }
//     });

//     // Show the "Brand not found" message if no brands match the search query
//     if (!found) {
//       $("#search-results").html(
//         '<div class="error-msg" style="color: red; text-align: center; padding: 10px;">Brand not found!</div>'
//       );
//     } else {
//       $("#search-results").empty();
//     }

//     // Reset the "Show More" button visibility when search box is cleared
//     if ($(this).val() === "") {
//       $("#menu_mb_ul li").hide();
//       showBrands(0, 10); // Show first 10 brands
//       $("#show-more-btn").show();
//     } else {
//       $("#show-more-btn").hide();
//     }
//   });
// });

$(document).ready(function () {
  // Initialize the count of brands to be shown
  var brandsToShow = 10;

  // Function to show brands
  function showBrands(startIndex, endIndex) {
    $("#menu_mb_ul li").slice(startIndex, endIndex).show().find(".mobile-load-icon").addClass("mobile-load-iconing");
    removeLoaderAfterTimeout();
  }

  // Function to remove loader after a timeout
  function removeLoaderAfterTimeout() {
    var timeout = setInterval(function () {
      if ($(".mobile-load-iconing").length > 0) {
        $(".mobile-load-iconing").removeClass("mobile-load-iconing");
        clearInterval(timeout);
      }
    }, 1500);
  }

  // Initially hide all brands
  $("#menu_mb_ul li").hide();

  // Initially show the first 10 brands when .mb_nav_ul is clicked
  $(document).on("click", ".mb_nav_ul", function () {
    brandsToShow = 10; // Reset brandsToShow to 10
    $("#menu_mb_ul li").hide(); // Hide all brands initially
    showBrands(0, brandsToShow); // Show first 10 brands
    $("#show-more-btn").show(); // Ensure the "Show More" button is visible
  });

  // Event listener for "Show More" button
  $(document).on("click", "#show-more-btn", function () {
    var visibleCount = $("#menu_mb_ul li:visible").length;
    brandsToShow = visibleCount + 10; // Update brandsToShow
    showBrands(visibleCount, brandsToShow);

    // Hide the button if there are no more hidden brands
    if ($("#menu_mb_ul li:hidden").length === 0) {
      $(this).hide();
    }
  });

  // Event listener for search box input
  $(document).on("input", ".brand-search-box", function () {
    var searchQuery = $(this).val().toLowerCase();
    var found = false;
    $("#menu_mb_ul li").each(function () {
      var brandName = $(this).find("a span:last-child").text().toLowerCase();
      if (brandName.includes(searchQuery)) {
        $(this).show().find(".mobile-load-icon").addClass("mobile-load-iconing");
        found = true;
      } else {
        $(this).hide();
      }
    });

    // Remove the loader after a timeout
    removeLoaderAfterTimeout();

    // Show the "Brand not found" message if no brands match the search query
    if (!found) {
      $("#search-results").html(
        '<div class="error-msg" style="color: red; text-align: center; padding: 10px;">Brand not found!</div>'
      );
    } else {
      $("#search-results").empty();
    }

    // Reset the "Show More" button visibility when search box is cleared
    if ($(this).val() === "") {
      $("#menu_mb_ul li").hide();
      showBrands(0, brandsToShow); // Show brands according to the previous "Show More" actions
      if ($("#menu_mb_ul li:hidden").length > 0) {
        $("#show-more-btn").show();
      } else {
        $("#show-more-btn").hide();
      }
    } else {
      $("#show-more-btn").hide();
    }
  });

  // Initially hide all brands
  $("#menu_mb_ul li").hide();
});

